import { typography } from '@vtb/ui-kit3';
import styled from 'styled-components';

export const Title = styled.h3`
  ${typography['Main/XL']};
  color: ${({ theme }) => theme.color.text.staticWhite};
  font-weight: 500;
  margin: 0px;
`;

export const Text = styled.p`
  ${typography['Main/XS']};
  color: ${({ theme }) => theme.color.text.staticWhite};
  text-align: center;
  white-space: pre;
  margin: 0px;
`;

export const Container = styled.div`
  max-width: 700px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const LogoImgBox = styled.div`
  margin-top: 30px;
`;
